import React, { useState } from "react";
import { Table, Collapse } from "react-bootstrap";
import ReportDetails from '../reportDetails/reportDetails'

import "./reportTable.scss";


const ReportTable = ({ reports }) => {
  const [expandedRow, setExpandedRow] = useState(null);

  // console.log("reports:", reports);
  return (
    <Table bordered hover className="no-hover-effect">
      <thead>
        <tr>
          <th>From</th>
          <th>Institution</th>
          <th>Security Name</th>
          <th>BPID</th>
          <th>Status</th>
          <th>Date Received</th>
        </tr>
      </thead>
      <tbody>
        {reports.length === 0 ? (
          <tr>
            <td colSpan="6" className="text-center">No reports</td>
          </tr>
        ) : (
          reports.map((report) => (
            <React.Fragment key={report.id}>
              <tr onClick={() => setExpandedRow(expandedRow === report.id ? null : report.id)}>
                <td>{report.from}</td>
                <td>{report.institution}</td>
                <td>{report.securityName}</td>
                <td>{report.clients[0].bpId}</td>
                <td>{report.status}</td>
                <td>{report.dateReceived ? report.dateReceived : "N/A"}</td>
              </tr>

              {/* Collapsible row for report details */}
              {expandedRow === report.id && (
                <tr>
                  <td colSpan="6">
                    <Collapse in={expandedRow === report.id}>
                      <div>
                        <ReportDetails 
                          report={{
                            ...report,
                            files: Object.values(report.files).flat(), // Flatten file structure
                          }} 
                        />
                      </div>
                    </Collapse>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))
        )}
      </tbody>
    </Table>
  );
};

export default ReportTable;
